module.exports = __webpack_public_path__ + "static/media/about_ellipse_yellow.298189e6.svg";